import { createContext } from 'react';

const solicitudContext = createContext();

export default solicitudContext;